export default 'https://tme.understood.org/assets/lanes.6c5568a3.glb'